import { render, staticRenderFns } from "./UiHeaderGet.vue?vue&type=template&id=1d1a559a&scoped=true"
import script from "./UiHeaderGet.vue?vue&type=script&lang=js"
export * from "./UiHeaderGet.vue?vue&type=script&lang=js"
import style0 from "./UiHeaderGet.vue?vue&type=style&index=0&id=1d1a559a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a559a",
  null
  
)

export default component.exports